import { render, staticRenderFns } from "./KatexText.vue?vue&type=template&id=1cc55bd2&scoped=true&lang=pug&"
import script from "./KatexText.vue?vue&type=script&lang=ts&"
export * from "./KatexText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc55bd2",
  null
  
)

export default component.exports